operations:
  load-models: Load Models
  load-models-status:
    loading: Loading
    ready: Ready
docs:
  theme:
    navbar:
      appearance:
        title: Appearance
'controls-island':
  'fade-on-hover':
    enable: Auto hide
    disable: Always show
  'open-settings': Open settings
  'open-chat': Open Chat
  'refresh': Refresh
  'center-main-window': Move to screen center
  'open-hearing-controls': Open hearing Controls
  'drag-to-move-window': Drag to move window
  'stop-speaking': Stop speaking
  'speaker-idle': Speaker
  'switch-to-light-mode': Switch to light mode
  'switch-to-dark-mode': Switch to dark mode
  'pin-on-top': Pin on top
  'unpin-from-top': Unpin from top
  'switch-profile': Switch Profile
  'close': Close
  'expand': Expand
  'collapse': Collapse
  'login': Sign in
  'logging-in': Signing in...
  'account': Account
  'logout': Sign out

widgets:
  close: Close widget
  empty:
    title: No widget active
    description: Widgets will appear here when a tool or plugin spawns one.
  loading: Loading widget…
  waiting: Waiting for widget data for "{id}"…

notice:
  'fade-on-hover':
    title: Fade on Hover
    intro: Automatically fades the character when your cursor roams nearby. It helps reduce distractions while keeping your character visible.
    opacity: After turning on, the opacity drops to {value} for both {targets} when your cursor is nearby.
    toggle: You can toggle it off by hovering at {controls}, then clicking the {icon} again.
    controls-label: Controls Island
    icon-label: eye-slash icon
    value: '0'
    targets: Character and UI
    confirm: Got it
    dont-show-again: Don’t show again
    preparing: Preparing…
    read-more: Read more
    preview-title: What is it?

about:
  subtitle: Desktop ver.
  current-version: Current Version
  common:
    cancel: Cancel
  links:
    title: Links
    home: Home
    documentation: Documentations
    github: GitHub
  update:
    lane:
      label: Update lane
      description: Choose channel release to follow
      placeholder: Choose update lane
    channels:
      auto: Auto
      stable: Stable
      alpha: Alpha
      beta: Beta
      nightly: Nightly
      canary: Canary
    status:
      downloading: Downloading update...
      error-prefix: Error
      latest: Up to date (v{version}).
      downloaded:
        windows: Update ready to install silently (v{version}).
        restart: Update ready to install on restart (v{version}).
    actions:
      download: Download Update
      download-short: Download
      confirm-download: Confirm Download
      check-for-updates: Check for updates
      checking: Checking...
      latest-version: Latest version
      disabled-dev: Updates disabled in Dev
      retry-check: Retry Check
      restart-silent: Restart to update silently
      restart-install: Restart to install update
      confirm-restart: Confirm Restart
    dialog:
      title: Update Available
      description: A new version (v{version}) is available.
      no-release-notes-markdown: _No release notes provided._
